import React from "react";

const FgdFooter = () => {
  const date: any = new Date();

  return (
	<footer className="fgd-footer">
	  <div className="wrapper">
		<div className="wrapper">
		  <div className="footer-content">
			<div className="links">
			  <ul>
			  <li key={'contact-link'}>
					  <a href={'https://www.mcdonalds.com/us/en-us/contact-us.html'} target={'_blank'}>Contact Us</a>
					</li>
			  </ul>
			</div>
			<div className="copyright">
			  <ul>
				<li>&copy;Copyright&nbsp;{date.getFullYear()}</li>
				<li>
				  <a href={'/privacy'}>View the Marketing Exchange Privacy Statement</a>.
				  <br />
				  <br />
				  <a href={'/terms'}>View Terms & Conditions</a>. PLEASE CAREFULLY READ AND UNDERSTAND THESE TERMS OF USE. THEY CONTAIN LIMITATIONS ON McDONALD’S LIABILITY AND OTHER PROVISIONS THAT AFFECT YOUR LEGAL RIGHTS.
				</li>
			  </ul>
			</div>
		  </div>
		</div>
	  </div>
	</footer>
  )
};

export default FgdFooter;
